import { Dialog } from '@/components/ui/dialog';

import { useIntegration } from '../model';

import CustomIntegrationSetup from './CustomIntegrationSetup';
import OauthIntegrationSetup from './OauthIntegrationSetup';
import SharefileIntegrationSetup from './SharefileIntegrationSetup';

const setupComponentMap = {
  custom: CustomIntegrationSetup,
  oauth: OauthIntegrationSetup,
  'share-file': SharefileIntegrationSetup,
};

const IntegrationSetupDialog = () => {
  const { isActivateOpen, type, resetIntegration } = useIntegration();

  const onOpenChange = (open: boolean) => {
    if (!open) resetIntegration();
  };

  const SetupComponent = type ? setupComponentMap[type] : null;

  return (
    <Dialog open={isActivateOpen} onOpenChange={onOpenChange}>
      {SetupComponent && <SetupComponent />}
    </Dialog>
  );
};

export default IntegrationSetupDialog;
